import React from 'react';
import { LoanDetailFooterWrapper, AreaBox } from './style';
import { EditorContents } from 'styles/styleArea';

const LoanDetailFooter = ({ contents = {} }) => {
  return (
    <LoanDetailFooterWrapper>
      <AreaBox>
        <EditorContents
          name="loanDetail"
          dangerouslySetInnerHTML={{ __html: contents }}
        />
      </AreaBox>
    </LoanDetailFooterWrapper>
  );
};

export default LoanDetailFooter;
